/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UnlinkedMembership interface.
 */
export function instanceOfUnlinkedMembership(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    if (!('sourceId' in value) || value['sourceId'] === undefined)
        return false;
    if (!('payerEmail' in value) || value['payerEmail'] === undefined)
        return false;
    if (!('payerFirstName' in value) || value['payerFirstName'] === undefined)
        return false;
    if (!('payerLastName' in value) || value['payerLastName'] === undefined)
        return false;
    if (!('adherentFirstName' in value) || value['adherentFirstName'] === undefined)
        return false;
    if (!('adherentLastName' in value) || value['adherentLastName'] === undefined)
        return false;
    if (!('adherentEmail' in value) || value['adherentEmail'] === undefined)
        return false;
    if (!('tierName' in value) || value['tierName'] === undefined)
        return false;
    if (!('tierDescription' in value) || value['tierDescription'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    return true;
}
export function UnlinkedMembershipFromJSON(json) {
    return UnlinkedMembershipFromJSONTyped(json, false);
}
export function UnlinkedMembershipFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'source': json['source'],
        'sourceId': json['source_id'],
        'payerEmail': json['payer_email'],
        'payerFirstName': json['payer_first_name'],
        'payerLastName': json['payer_last_name'],
        'adherentFirstName': json['adherent_first_name'],
        'adherentLastName': json['adherent_last_name'],
        'adherentEmail': json['adherent_email'],
        'tierName': json['tier_name'],
        'tierDescription': json['tier_description'],
        'amount': json['amount'],
        'orderDate': (new Date(json['order_date'])),
        'state': json['state'],
    };
}
export function UnlinkedMembershipToJSON(json) {
    return UnlinkedMembershipToJSONTyped(json, false);
}
export function UnlinkedMembershipToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'source': value['source'],
        'source_id': value['sourceId'],
        'payer_email': value['payerEmail'],
        'payer_first_name': value['payerFirstName'],
        'payer_last_name': value['payerLastName'],
        'adherent_first_name': value['adherentFirstName'],
        'adherent_last_name': value['adherentLastName'],
        'adherent_email': value['adherentEmail'],
        'tier_name': value['tierName'],
        'tier_description': value['tierDescription'],
        'amount': value['amount'],
        'order_date': ((value['orderDate']).toISOString()),
        'state': value['state'],
    };
}
